import styles from "./UnitPrice.module.scss";

type Props = {
  /**
   * A string representing the display price of the product.
   */
  displayPrice: string;
  /**
   * A string representing the quantity of the product.
   */
  quantity: string;
  /**
   * A string representing the unit of measure of the product.
   */
  unitOfMeasure: string;
};

export const UnitPriceUI = ({
  displayPrice,
  quantity,
  unitOfMeasure,
}: Props) => {
  const unitPriceMessage = `${displayPrice} per ${quantity}${unitOfMeasure}`;
  return (
    <p data-testid="product:unit-price" className={styles.unitPrice}>
      {unitPriceMessage}
    </p>
  );
};
